var map = {
	"./ambassador-bg.webp": 1274,
	"./asset-2.png": 1275,
	"./btn-enter-bg.png": 1276,
	"./btn-enter-white-bg.webp": 1277,
	"./btn-more-bg.webp": 1278,
	"./casino-hover.webp": 1279,
	"./casino.webp": 1280,
	"./convenient.webp": 1281,
	"./es-bg.webp": 1282,
	"./event-sec-bg.webp": 1283,
	"./event-sport-bg.webp": 1284,
	"./fifa1-bg.jpg": 1285,
	"./fifa2-bg-cn.jpg": 1286,
	"./fifa2-bg.jpg": 1287,
	"./games-hover.webp": 1288,
	"./games.webp": 1289,
	"./gauge.webp": 1290,
	"./lottery-hover.webp": 1291,
	"./lottery.webp": 1292,
	"./master-bg.webp": 1293,
	"./p2p-hover.webp": 1294,
	"./p2p.webp": 1295,
	"./platform.webp": 1296,
	"./product-ctg-bg.webp": 1297,
	"./product-overview-bg.webp": 1298,
	"./professional.webp": 1299,
	"./safety.webp": 1300,
	"./slots-hover.webp": 1301,
	"./slots.webp": 1302,
	"./speed.webp": 1303,
	"./sports-hover.webp": 1304,
	"./sports.webp": 1305,
	"./video-bg.webp": 1306,
	"./wave.webp": 1307,
	"./wwr-bg.webp": 1308,
	"./wwr-img-b.webp": 1309,
	"./wwr-img.webp": 1310,
	"./wwr-subImg1.webp": 1311,
	"./wwr-subImg2.webp": 1312,
	"./wwr-subImg3.webp": 1313,
	"./x33-logo-cny.png": 1314
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 463;